// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-columns----columns-module---wrapper---ox6aW","block":"src-components-columns----columns-module---block---3dud8","column":"src-components-columns----columns-module---column---1ypjt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/columns/columns.module.css
// module id = 309
// module chunks = 35783957827783